const initialState = () => ({
  page: 1,
  dealer_page: 1,
  // Team's own filters. Each is sent to the list API and narrows the whole
  // result set server-side, not just the page in hand.
  role: [],
  hierarchy_level: [],
  status: "",
  // Dealer list (shares this module because it shares the pager).
  product_type: [],
  dealer_type: "",
  dealer_status: "",
  selected_tab: 0,
  display_daterange: "",
  date_range: [],
});

export default {
  namespaced: true,
  state: initialState(),

  mutations: {
    RESET_FILTERS(state) {
      Object.assign(state, initialState());
    },
  },
  actions: {
    resetFilters({ commit }) {
      commit("RESET_FILTERS");
    },
  },
  getters: {
    // Fresh copy of the filter defaults; used by filterChipsMixin's
    // dev coverage guard to detect applied-but-unregistered filters.
    getInitialFilters: () => initialState(),
    getFilters: (state) => {
      return state;
    },
  },
};
